import React, { Component } from 'react'
import { Button, Input, Select, Table } from 'antd'
import { Redirect } from 'react-router-dom'
import _ from 'lodash'

import './TemplateList.scss'

const { Search } = Input
const { Option } = Select

export default class TemplateList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            redirectTo: ''
        }

        this.handleCreateTemplate = this.handleCreateTemplate.bind(this)
    }

    handleCreateTemplate() {
        this.setState({ redirectTo: '/workdesk/template/new' })
    }

    render() {
        const { onTemplateChange, onFilterChange, onSearchBarInputChange, parentColumns, dataset, filter, locationList, estateList, selectedTemplateIdx } = this.props
        const { redirectTo } = this.state
        const { category, type, size, siteLocation, estateName } = filter

        if (redirectTo !== '')
            return <Redirect to={redirectTo}/>
        else
            return (
                <div className="TemplateList">
                    <div className="template-type-selector">
                    	<Button type="primary" onClick={this.handleCreateTemplate}>Create New</Button>
                    </div>
                    <div className="main-body">
                        <div className="filter">
                            <Select 
                                placeholder="Category" 
                                dropdownMatchSelectWidth={false} 
                                value={category}
                                onChange={onFilterChange.bind(this, 'category')}
                                allowClear
                            >
                                <Option value="RE">RE</Option>
                                <Option value="OF">OF</Option>
                                <Option value="MI">MI</Option>
                            </Select>
                            <Select 
                                placeholder="Type" 
                                dropdownMatchSelectWidth={false} 
                                value={type}
                                onChange={onFilterChange.bind(this, 'type')}
                                allowClear
                            >
                                <Option value="Apartment">Apartment</Option>
                                <Option value="House">House</Option>
                                <Option value="Subdivided Flat">Subdivided Flat</Option>
                                <Option value="Shop">Shop</Option>
                                <Option value="NGO">NGO</Option>
                                <Option value="Restaurant">Restaurant</Option>
                                <Option value="Elderly House">Elderly House</Option>
                                <Option value="School">School</Option>
                                <Option value="Office">Office</Option>
                            </Select>
                            <Select 
                                placeholder="Size" 
                                dropdownMatchSelectWidth={false} 
                                value={size}
                                onChange={onFilterChange.bind(this, 'size')}
                                allowClear
                            >
                                <Option value="<= 300">&lt;= 300</Option>
                                <Option value="301 - 500">301 - 500</Option>
                                <Option value="501 - 800">501 - 800</Option>
                                <Option value="> 800">&gt; 800</Option>
                            </Select>
                            <Select 
                                placeholder="Location" 
                                dropdownMatchSelectWidth={false} 
                                value={siteLocation}
                                onChange={onFilterChange.bind(this, 'siteLocation')}
                                allowClear
                            >
                                {
                                    _.map(locationList, (location, i) => (
                                        <Option key={location} value={location}>{location}</Option>
                                    ))
                                }
                            </Select>
                            <Select 
                                placeholder="Estate" 
                                dropdownMatchSelectWidth={false} 
                                value={estateName}
                                onChange={onFilterChange.bind(this, 'estateName')}
                                allowClear
                            >
                                {
                                    _.map(estateList, (estate, i) => (
                                        <Option key={estate} value={estate}>{estate}</Option>
                                    ))
                                }
                            </Select>
                            <Search 
                                placeholder="Search Bar" 
                                style={{ width: 200 }}
                                onSearch={onSearchBarInputChange.bind(this)}
                            />
                        </div>
                        <div className="template-list">
                            <Table 
                                className="template-table"
                                rowKey={'_id'}
                                columns={parentColumns}
                                dataSource={dataset}
                                pagination={false}
                                rowClassName={(record, index) => index === selectedTemplateIdx ? 'selected' : ''}
                                onRowClick={onTemplateChange}
                            />
                        </div>
                    </div>
                </div>
            )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/TemplateList/TemplateList.js